import React, { Component } from 'react'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/grid'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/dataZoom'
import './Index.scss'

export default class index extends Component {
  constructor(props) {
    super(props)
    this.initPie = this.initPie.bind(this)
  }

  initPie() { //初始化echarts
    let myChart = echarts.init(this.ID)
    let chartData = this.props.data
    let mold = this.props.mold
    let unitSite = this.props.type
    let baseColor = unitSite.color
    let barOption = {
      color: baseColor,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        left: '3%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      dataZoom: [
        {
          type: 'inside',
        },
      ],
      series: [
        {
          name: '',
          type: 'bar',
          barMaxWidth: '100',
          data: [],
        },
      ]
    }
    if (chartData && chartData[`${unitSite.name}_charts`]) {
      chartData[`${unitSite.name}_charts`].forEach((item) => {
        if (mold === 'single') {
          barOption.xAxis[0].data.push(item.date)
        } else {
          barOption.xAxis[0].data.push(item.username)
        }
        barOption.series[0].name = unitSite.title + '(' + unitSite.unit + ')'
        if (item.value.toString().indexOf('.') > -1) {
          barOption.series[0].data.push(item.value.toFixed(2))
        } else {
          barOption.series[0].data.push(item.value)
        }
      })
    }

    //设置options
    myChart.setOption(barOption)
    window.onresize = function () {
      myChart.resize()
    }
  }
  componentDidMount() {
    this.initPie()
  }
  componentDidUpdate() {
    this.initPie()
  }
  render() {
    const { width = "100%", height = "300px" } = this.props
    let chartData = this.props.data
    let total
    let unitSite = this.props.type
    if (chartData && chartData[`total_${unitSite.name}`]) {
      total = chartData[`total_${unitSite.name}`]
      if (total.toString().indexOf('.') > -1) {
        total = total.toFixed(2)
      }
    }

    return (
      <div className={`report-charts report-chart-${unitSite.name}`}>
        <div className="report-chart-title">
          <p className="pull-left">
            <span className="report-chart-title-number">
              {total || 0}
            </span>
            {unitSite.unit}
          </p>
          <p>
            <span className="chart-sub-tag pull-right"><i /></span>
            <span className="chart-sub-title pull-right">{unitSite.title}</span>
          </p>
        </div>
        <div ref={ID => this.ID = ID} style={{ width, height }}></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BarEcharts/index.js